import { createContext } from 'react';

export type AbContextValue = {
  cohortIds: Record<string, number>;
};

export const AbContext = createContext({ cohortIds: {} });
